import get from 'lodash/get';

import { saveAndVisitPageThunk } from 'app/Explorer/thunks';
import { notifySuccess, notifyFailure, notifyAlert } from 'app/Notifications/actions';
import { visitPage } from 'app/Router/actions';

import {
  publishPageFailure,
  publishPageSuccess,
  unpublishPageFailure,
  unpublishPageSuccess
} from './actions';

/**
 * publish a page
 * @param {object} pagePayload - the page object to be published
 * @param {boolean} publishNow - publish the page now
 * @param {object} dateTime - datetime object
 * @param {boolean} isTestContent - whether page is published for testing purposes only
 * @returns {Function} thunk
 */
export const publishPageThunk = (
  pagePayload,
  publishNow,
  dateTime,
  isTestContent = false
) => async (dispatch, _, { api }) => {
  dispatch(notifyAlert(`Publishing page ${pagePayload.PageName}`));
  try {
    const pageSuccessData = await api.page.publishPage(
      pagePayload,
      publishNow,
      dateTime,
      isTestContent
    );
    dispatch(publishPageSuccess(pageSuccessData));
    dispatch(notifySuccess(`Page ${pagePayload.PageName} has been published.`));
    dispatch(visitPage(pageSuccessData.Id, pageSuccessData.Version));
  } catch (error) {
    dispatch(publishPageFailure(pagePayload, error));

    if (get(error, 'body.conflictingRoutes')) {
      dispatch(notifyFailure(undefined));
    } else {
      dispatch(notifyFailure(error.message));
    }
  }
};

/**
 * save, visit, and publish a page
 * @param {object} pagePayload - the page object to be published
 * @param {boolean} publishNow - publish the page now
 * @param {object} dateTime - datetime object
 * @param {boolean} isTestContent - whether page is published for testing purposes only
 * @returns {Function} thunk
 */
export const saveAndPublishPageThunk = (
  pagePayload,
  publishNow,
  dateTime,
  isTestContent = false
) => async dispatch => {
  const response = await dispatch(saveAndVisitPageThunk());
  if (response) {
    await dispatch(
      publishPageThunk(
        {
          ...pagePayload,
          LastTimestamp: response.DateModified
        },
        publishNow,
        dateTime,
        isTestContent
      )
    );
  }
};

/**
 * thunk to unpublish a page
 * @param {object} pagePayload - the pagePayload object
 * @returns {Function} thunk
 */
export const unpublishPageThunk = pagePayload => async (dispatch, _, { api }) => {
  dispatch(notifyAlert(`Unpublishing page ${pagePayload.PageName}.`));
  try {
    const successData = await api.page.unpublishPage(pagePayload);
    dispatch(unpublishPageSuccess(pagePayload, successData));
    dispatch(notifySuccess(`Page ${pagePayload.PageName} has been unpublished.`));
    dispatch(visitPage(successData.Id, successData.Version));
  } catch (error) {
    dispatch(unpublishPageFailure(pagePayload, error));
    dispatch(notifyFailure(error.message));
  }
};
